export default [
  {
    id: 0,
    width: 900,
    css: "cell_bk1",
    css_gra: "cell_bk1_grad bottom-background",
    css_gra_hov: "cell_bk1_gradiente",
    isOtherDesing: false,
  },
  {
    id: 1,
    width: 900,
    css: "cell_bk2",
    css_gra: "cell_bk2_grad bottom-background",
    css_gra_hov: "cell_bk2_gradiente",
    isOtherDesing: true,
  },
  {
    id: 2,
    width: 900,
    css: "cell_bk3",
    css_gra: "cell_bk3_grad bottom-background",
    css_gra_hov: "cell_bk3_gradiente",
    isOtherDesing: true,
  },
  {
    id: 3,
    width: 900,
    css: "cell_bk4",
    css_gra: "cell_bk4_grad bottom-background",
    css_gra_hov: "cell_bk4_gradiente",
    isOtherDesing: true,
  },
  // {
  //   id: 4,
  //   width: 900,
  //   css: "cell_bk5",
  //   css_gra: "cell_bk5_grad bottom-background",
  //   css_gra_hov: "cell_bk5_gradiente",
  //   isOtherDesing: true,
  // },
  {
    id: 5,
    width: 900,
    css: "cell_bk6",
    css_gra: "cell_bk6_grad bottom-background",
    css_gra_hov: "cell_bk6_gradiente",
    isOtherDesing: true,
  },
];
